import React from 'react';
import { Row, Col } from 'antd';
import MemoDatePicker from '@components/summary-panel/SummaryContainer/DatePickers';

const DatePickerWithMenu = ({
  interval,
  comparisonInterval,
  validateUpdateInterval,
  summaryDatePickerRef,
  comparisonDatePickerRef,
}: {
  interval: any;
  comparisonInterval: any;
  validateUpdateInterval: (dates: any, short: boolean) => void;
  summaryDatePickerRef: any;
  comparisonDatePickerRef: any;
}) => {
  return (
    <Row align="middle" gutter={16}>
      <Col>
        <MemoDatePicker
          key="policy-tracking-date-picker"
          interval={interval}
          comparisonInterval={comparisonInterval}
          durationAllowed={true}
          validateUpdateInterval={validateUpdateInterval}
          summaryDatePickerRef={summaryDatePickerRef}
          comparisonDatePickerRef={comparisonDatePickerRef}
        />
      </Col>
    </Row>
  );
};

export default DatePickerWithMenu;
